import styled, { css } from 'styled-components';
import screen from 'superior-mq';
import { rem } from 'polished';
import { bp } from 'Styles/helpers';

const Subhead = styled.span`
  display: block;
  margin-bottom: 30px;
  font-size: 1rem;
  color: inherit;
  text-align: ${props => props.align || 'center'};

  ${screen.below(bp.laptop, `
    margin-bottom: 15px;
  `)}

  ${screen.below(bp.mobile, `
    font-size: ${rem(12)}
  `)}

  ${props => props.styles && css`
    ${props.styles}
  `}
`;

export default Subhead;
